<template>
  <div id="DamageReport">
    <v-card rounded>
      <v-row no-gutters dense class="pa-4">
        <template>
          <v-row justify="space-between">

            <v-col cols="12" sm="6" lg="3">
              <v-card class="elevation-4 rounded-lg pa-5">
                <v-card-text class="pa-0">
                  <h4 class="mb-3"><span class="primary--text text-uppercase">{{ $t('monitoring.trasnport_unit')}}</span></h4>
                  <h4 class="mb-3"><span class="primary--text">VIN: </span>{{ unit.vin_number ? unit.vin_number : '--' }}</h4>
                  <h4 class="mb-3"><span class="primary--text">{{ $t('monitoring.unit_type') }}: </span>
                    {{ unit.unit_types && unit.unit_types.alias ? unit.unit_types.alias : '--' }}
                  </h4>
                  <h4 class="mb-3"><span class="primary--text">{{ $t('monitoring.numberEconomic') }}:</span>
                    {{ unit.unit_number ? unit.unit_number : '--' }}
                  </h4>
                  <h4 class="mb-0">
                    <span class="primary--text">{{ $t('monitoring.plaque') }}: </span>
                    <span v-if="!unit || !unit.plates || unit.plates.length === 0">{{ $t('units.noPlates') }}</span>
                    <span v-if="unit && unit.plates && unit.plates.length > 0">
                      <v-chip small v-for="plate in unit.plates" :key="plate.id" class="mx-1 pr-0" color="secondary">
                        {{ plate.plate_number }}
                        <v-chip small class="ml-1" color="primary">{{ plate.country.name }}</v-chip>
                      </v-chip>
                    </span>
                  </h4>
                </v-card-text>
              </v-card>
            </v-col>

            <v-col cols="12" sm="6" lg="3">
              <v-card class="elevation-4 rounded-lg pa-5">
                <v-card-text class="pa-0">
                  <h4 class="mb-3"><span class="primary--text text-uppercase">{{ $t('monitoring.lastInspection')
                      }}</span></h4>

                  <h4 class="mb-3">
                    <span class="primary--text">{{ $t('general.duration') }}: </span>
                    {{ latestInspectionData.duration }}
                  </h4>
                  <h4 class="mb-3">
                    <span class="primary--text">{{ $t('general.site') }}: </span>
                    {{ latestInspectionData.site_name }}
                  </h4>
                  <h4 class="mb-3">
                    <span class="primary--text">{{ $t('monitoring.reportedDamage') }}: </span>
                    {{ latestInspectionData.damage_count }}
                  </h4>

                  <h4 class="mb-0"></h4>
                </v-card-text>
              </v-card>
            </v-col>
          </v-row>
        </template>
        <!-- <v-col cols="6">
          <v-row no-gutters justify="end">
            <v-btn depressed color="primary" @click="getGraphic">{{$t('monitoring.graphic')}}</v-btn>
          </v-row>
        </v-col> -->
        <v-col cols="12"><v-divider class="my-6"/></v-col>
        <v-col cols="6">
          <h3 class="primary--text">{{$t('monitoring.damageGallery')}}</h3>
        </v-col>
        <v-col cols="6">
          <v-row no-gutters justify="end" align="center">
            <v-btn depressed color="primary" class="mr-6" @click="openFilter = true">
              {{$t('reports.filter')}}
              <v-icon small class="ml-2">
                fas fa-align-center
              </v-icon>
            </v-btn>
            <v-btn depressed color="primary" @click="dowloadPhotos" :loading="loadButton"
              :disabled="loadButton || incidents.length === 0">
              {{$t('monitoring.downloadPhotos')}}
              <v-icon small class="ml-2">mdi-download</v-icon>
            </v-btn>
          </v-row>
        </v-col>
        <v-col cols="6" class="mt-3" v-if="!loadGallery && galleryNew.length > 0">
          <v-checkbox v-model="allGallery" :label="$t('monitoring.selectAll')" hide-details @change="selectedAll">
          </v-checkbox>
        </v-col>
        <v-col cols="12" class="mt-5">
          <span v-if="loadTable">
            <v-progress-linear v-if="loadTable" color="primary" indeterminate/>
            <p class="text-center">{{$t('general.loading')}}</p>
          </span>
          <span v-if="!loadTable && incidents.length === 0">
            <v-row dense no-gutters align="center" justify="center">
              <p>{{$t('general.noRegister')}}</p>
            </v-row>
          </span>
        </v-col>
        <v-col cols="12" class="mt-5" v-if="incidents.length > 0 && !loadGallery && galleryNew.length === 0">
          <v-row dense no-gutters align="center" justify="center">
            <p>{{$t('general.noGallery')}}</p>
          </v-row>
        </v-col>
        <!-- Galeria de daños -->
        <v-col cols="12" class="mt-5" v-if="loadGallery">
          <v-row no-gutters dense align="center" justify="center">
            <v-progress-circular indeterminate color="primary"></v-progress-circular>
            <span class="text-center primary--text ml-2">{{$t('general.loading')}}</span>
          </v-row>
        </v-col>
        <v-col cols="12" v-if="galleryNew.length > 0 && !loadGallery" class="mt-5">
          <v-expansion-panels flat v-model="activePanel">
              <v-expansion-panel v-for="evidencia in galleryNew" :key="evidencia.id" class="mb-3"> 
                  <v-expansion-panel-header class="grey lighten-4 pa-0">
                      <v-row dense align="center" class="py-3 px-4">
                          <v-col cols="12" sm="10" class="d-flex align-center py-0">
                              <v-checkbox v-model="selectGallery" :value="evidencia.id" @change="allGallery = false" class="mt-0 pt-0" hide-details></v-checkbox>
                              <h4 class="font-weight-bold ml-2">#{{evidencia.number}} {{ evidencia.name }} - {{evidencia.date}}</h4>
                              <v-tooltip bottom>
                                  <template v-slot:activator="{ on, attrs }">
                                      <v-btn depressed color="primary" fab x-small v-bind="attrs" v-on="on" 
                                          :disabled="loadReport[evidencia.id]" 
                                          :loading="loadReport[evidencia.id]" 
                                          class="ml-6" 
                                          @click.stop="downloadByInspection(evidencia.id, evidencia.name)">
                                          <v-icon>mdi-file-download-outline</v-icon>
                                      </v-btn>
                                  </template>
                                  <span>{{$t('general.downloadReports')}}</span>
                              </v-tooltip>
                          </v-col>
                      </v-row>
                  </v-expansion-panel-header>
                  <v-expansion-panel-content class="white">
                    <v-row dense>
                        <v-col cols="12">
                            <v-row dense justify="center" class="pt-4 pb-5">
                                <h5 class="mr-6 text-uppercase subtitle-2">
                                    <span class="primary--text font-weight-bold ml-2 mr-2">{{$t('general.duration')}}:</span> {{evidencia.duration}}
                                </h5>
                                <h5 class="mr-6 text-uppercase subtitle-2">
                                    <span class="primary--text font-weight-bold ml-2 mr-2">Inspector:</span> {{evidencia.inspector}}
                                </h5>
                                <h5 class="mr-6 text-uppercase subtitle-2">
                                    <span class="primary--text font-weight-bold ml-2 mr-2">{{$t('general.site')}}:</span> {{evidencia.site.name}}
                                </h5>
                                <h5 class="mr-6 text-uppercase subtitle-2">
                                    <span class="primary--text font-weight-bold ml-2 mr-2">{{$t('monitoring.reportedDamage')}}:</span> {{evidencia.gallery ? evidencia.gallery.length : 0}}
                                </h5>
                            </v-row>
                        </v-col>
                    </v-row>
                    <v-divider class="my-3" />
                    <h5 class="primary--text font-weight-bold mb-3 subtitle-1">{{$t('monitoring.photographicEvidence')}}</h5>
                    <v-row justify="start" align="center">
                        <v-slide-group>
                            <v-slide-item v-for="(item, i) in evidencia.gallery" :key="i">
                                <div class="my-4">
                                    <v-card width="300" tile class="mx-2">
                                        <v-hover v-slot="{ hover }">
                                            <v-img height="200px" :src="`${item.path}`" :lazy-src="`${item.path}`">
                                                <v-overlay v-if="hover" absolute>
                                                    <v-btn small color="white" outlined @click="viewImageDetails(item, evidencia)">{{$t('inspections.viewImgs')}}</v-btn>
                                                </v-overlay>
                                            </v-img>
                                        </v-hover>
                                        <v-card-actions class="pt-0 pb-3 mt-3">
                                            <v-spacer></v-spacer>
                                            <v-btn :color="show && activeItem === item ? 'success' : 'primary'" x-small depressed rounded
                                                @click="show && activeItem === item ? inactive(item) : active(item, evidencia.id)">
                                                {{ show && activeItem === item ? $t('general.hideDetail') : $t('general.seeDetail') }}
                                            </v-btn>
                                        </v-card-actions>
                                    </v-card>
                                    <v-card class="mx-2 mt-n1" width="300" outlined tile v-if="show && activeItem === item">
                                        <v-card-text>
                                            <v-row dense no-gutters justify="space-between" align="center" class="mb-2">
                                                <h5 class="font-weight-bold mb-0">{{ item.issues_notes }}</h5>
                                                <span class="caption grey--text text--darken-2">
                                                    {{ i + 1 }}/{{ evidencia.gallery.length }}
                                                </span>
                                            </v-row>                                        
                                            <h5 class="mb-1">
                                              <span class="primary--text">{{ $t('monitoring.question') }}:</span>
                                              {{ item.name }}
                                            </h5>
                                            <h5 class="primary--text mb-1">{{ $t('monitoring.levelDamage') }}:
                                              <span v-for="(level, i) in levels" :key="i">
                                                <v-chip v-if="level.value === item.damage_level && item.damage_level !== 'NONE'" small :color="level.value === item.damage_level ? level.color : ''" class="mr-3 white--text">
                                                  {{ $t(level.text) }}
                                                </v-chip>
                                              </span>
                                            </h5>
                                        </v-card-text>
                                    </v-card>
                                </div>
                            </v-slide-item>
                        </v-slide-group>
                    </v-row>
                  </v-expansion-panel-content>
              </v-expansion-panel>
          </v-expansion-panels>
        </v-col>
      </v-row>  
    </v-card>
    <!-- Dialogo para el proceso de filtrado -->
    <v-dialog v-model="openFilter" width="400px">
      <v-card>
        <v-card-title class="d-flex justify-space-between grey lighten-3">
          {{$t('reports.filter')}}
          <v-btn icon @click="openFilter = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-divider class="mb-5"/>
        <v-card-text>
          <v-form v-model="valid" lazy-validation ref="form">
            <v-row dense>
              <v-col cols="12">
                <v-select v-model="filter.year" :items="years" :label="$t('monitoring.year')" outlined dense></v-select>
              </v-col>
              <!-- PENDIENTE DE CONFIRMAR SI SE DEJA O NO -->
              <!-- <v-col cols="12">
                <v-select v-model="filter.levelDamage" :items="damageLevels" :label="$t('monitoring.levelDamage')" outlined dense>
                  <template v-slot:select="data">
                    <span>{{ data }}</span>
                  </template>
                </v-select>
              </v-col> -->
              <v-col cols="12">
                <v-autocomplete clearable outlined dense 
                :items="users" 
                :item-text="getInspector" 
                item-value="id" 
                v-model="filter.inspector" 
                :label="$t('general.inspector')" 
                class="">
                </v-autocomplete>
              </v-col>
              <v-col cols="12">
                <v-autocomplete clearable outlined dense 
                :items="sites" 
                item-text="name" 
                item-value="id"
                v-model="filter.site" 
                :label="$t('general.site')" />
              </v-col>
            </v-row>
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-spacer/>
          <v-btn depressed color="error" @click="closeDialog()">{{$t('general.cancel')}}</v-btn>
          <v-btn depressed @click="getIncident" color="primary">
            {{$t('general.search')}}
            <v-icon small class="ml-2">fas fa-search</v-icon>
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- Dialogo grafica -->
    <!-- <v-dialog v-model="openGraphic" width="80%" persistent>
      <v-card>
        <v-card-title class="d-flex justify-space-between grey lighten-3">
          {{$t('monitoring.graphicTitle')}}
          <v-btn icon @click="openGraphic = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-row no-gutters dense align="center" justify="center">
          <v-col cols="12" v-if="loadGraphic" class="pa-5">
            <v-row no-gutters dense align="center" justify="center">
              <v-progress-circular indeterminate color="primary"></v-progress-circular>
              <span class="text-center primary--text ml-2">{{$t('general.loading')}}</span>
            </v-row>
          </v-col>
          <v-col cols="12" v-if="!loadGraphic && series.length > 0">
            <v-divider class="mb-5"/>
            <v-card-text>
              <apexchart type="heatmap" height="500" :options="chartOptions" :series="series"></apexchart>
            </v-card-text>
          </v-col>
          <v-col cols="12" v-if="!loadGraphic && series.length === 0" class="pa-5">
            <h4 class="text--center">{{$t('general.noData')}}</h4>
          </v-col>
        </v-row>
      </v-card>
    </v-dialog> -->
    <v-dialog scrollable v-model="imageDialog" width="800px">
      <v-card>
        <v-card-text class="pa-0">
          <v-img :src="`${viewItem.path}`"/>
        </v-card-text>
        <div class="pa-2">
          <v-chip small :color="viewItem.color" class="font-weight-bold mb-2">{{$t(viewItem.text)}}</v-chip>
          <p class="mb-0">
            <span class="font-weight-bold">{{ viewItem.name }}</span>
          </p>
          <p class="mb-0"> "{{ viewItem.description }}" </p>
        </div>
        <v-divider/>
        <v-card-actions>
          <v-spacer/>
          <v-btn color="primary" depressed @click="closeImgDialog">{{$t('general.close')}}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog scrollable v-model="imageDialogDetails" persistent width="600px">
      <v-card>
        <v-toolbar color="grey lighten-5" flat class="mb-5">
        </v-toolbar>
        <v-card-text>
          <template v-if="viewItemDetails.length > 1">
            <v-carousel hide-delimiters @change="updateCurrentImageIndex">
              <v-carousel-item v-for="(file, index) in viewItemDetails" :key="index">
                <v-img :src="file.path" />
              </v-carousel-item>
            </v-carousel>
          </template>
          <template v-else-if="viewItemDetails.length === 1">
            <v-img :src="viewItemDetails[0].path" />
          </template>
          <div class="d-flex justify-space-between align-center">
            <span><b>"{{ comment }}"</b></span>
            <span class="primary--text">{{ currentImageIndex + 1 }}/{{ viewItemDetails.length }}</span>
          </div>
          <div v-if="questionDescription">
            <h4 class="mt-2 primary--text">
              {{ $t('monitoring.question') }}:
              <span class="text--secondary">{{ questionDescription }}</span>
            </h4>
          </div>
          <div v-if="damage">
            <h4 class="mt-2 primary--text">
              {{ $t('monitoring.levelDamage') }}:
              <span v-for="(level, i) in levels" :key="i">
                <v-chip v-if="level.value === damage && damage !== 'NONE'" small :color="level.value === damage ? level.color : ''" class="mr-3 white--text">
                  {{ $t(level.text) }}
                </v-chip>
              </span>
            </h4>
          </div>
        </v-card-text>
        <v-divider />
        <v-card-actions>
          <v-spacer />
          <v-btn color="primary" depressed @click="closeImageDetails">{{ $t('general.close') }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>

export default {
  name: 'DamageReport',
  data () {
    return {
      idGallery: null,
      actualPage: 1,
      editedItem: '',
      loadTable: false,
      loadGallery: false,
      loadButton: false,
      loadGraphic: false,
      openGraphic: false,
      openFilter: false,
      imageDialog: false,
      activeItem: {},
      viewItem: {
        img: '',
        damage_level: '',
      },
      viewItemDetails: [],
      levelname: '',
      show: false,
      allGallery: false,
      selectGallery: [],
      gallery: [],
      galleryID: [],
      incidents: [],
       // PENDIENTE DE CONFIRMAR SI SE DEJA O NO
      levels: this.$constants.DAMAGE_LEVEL,
      activePanel: null,
      loadReport: {},
      options: {
        page: 1,
        itemsPerPage: 15,
        total: 0
      },
      series: [],
      sites: [],
      users: [],
      filter: {
        year: new Date().getFullYear(),
        site: null,
        inspector: null
         // PENDIENTE DE CONFIRMAR SI SE DEJA O NO
        // damage_level: null
      },
      valid: true,
      imageDialogDetails: false,
      currentImageIndex: 0,
      damage: '',
      comment: '',
      questionDescription: ''
    }
  },
  computed: {
     // PENDIENTE DE CONFIRMAR SI SE DEJA O NO
    // damageLevels () {
    //   return this.$constants.DAMAGE_LEVEL.map(item => ({
    //     value: item.value,
    //     text: this.$t(item.text)
    //   }))
    // },
    latestInspectionData() {
      const source = this.galleryNew;

      if (source && source.length > 0) {
        const latest = source[0]
        
        // Contamos el total daños reportados en la inspección
        const damageCount = latest.gallery ? latest.gallery.length : 0;
        return {
          duration: latest.duration || 'N/A',
          site_name: latest.site.name || 'N/A',
          damage_count: damageCount,
        };
      }
      return {
        duration: 'N/A',
        site_name: 'N/A',
        damage_count: 0
      };
    },
    unit () {
      return JSON.parse(localStorage.getItem('unit'))
    },
    years () {
      let year = new Date().getFullYear()
      let arrYears = []
      for (let i = year; i >= 2000; i--) {
        arrYears.push(i)
      }
      return arrYears
    },
    chartOptions () {
      let items = []
      this.series.forEach(e => { items.push(e.data.length) })
      let range = Math.max(...items)
      let categories = []    
      for (let i = 1; i <= range; i++) {
        categories.push('Inspeccion ' + i)
      }
      return {
        chart: {
          height: 500,
          type: 'heatmap',
        },
        plotOptions: {
          heatmap: {
            shadeIntensity: 0.5,
            radius: 0,
            useFillColorAsStroke: true,
            colorScale: {
              ranges: [
                {
                  from: 0,
                  to: 0,
                  name: this.$t('general.none'),
                  color: '#E0E0E0'
                },
                {
                  from: 1,
                  to: 1,
                  name: this.$t('monitoring.low'),
                  color: '#00A100'
                },
                {
                  from: 2,
                  to: 2,
                  name: this.$t('monitoring.warning'),
                  color: '#FFB200'
                },
                {
                  from: 3,
                  to: 3,
                  name: this.$t('monitoring.high'),
                  color: '#FF0000'
                }
              ]
            }
          }
        },
        dataLabels: {
          enabled: false
        },
        xaxis: {
          categories
        },
        tooltip: {
          custom: function ({series, seriesIndex, dataPointIndex, w}) {
            const range = w.globals.initialConfig.plotOptions.heatmap.colorScale.ranges
            const name = w.globals.seriesNames[seriesIndex]
            const item = series[seriesIndex][dataPointIndex]
            const level = range.find((e, i) => i === item)
            const title = w.globals.labels[dataPointIndex]
            return (
              '<div class="card">' +
                '<div class="grey lighten-4">' +
                  '<h3 class="pa-1 ml-2"><b>' + title + '</b></h3>' +
                '</div>' +
                '<div class="pa-2 white">' +
                  '<span>' + '<b>' + name + ': ' + '</b>' + '<span>' + level.name + '</span>' + '</span>' +
                '</div>' +
              '</div>'
            )
          }
        }
      }
    },
    galleryNew () {
      // SE PUEDE MEJORAR
      let itemGallery = []
      if (this.incidents.length > 0) {
        itemGallery = this.incidents
          .filter(e => e.consecutive_number !== null)
          .map(e => {
            return {
              id: e.id,
              number: e.consecutive_number,
              name: e.name,
              date: e.created_at,
              duration: e.duration,
              site: e.site.name,
              inspector: e.user.name + ' ' + e.user.last_name,
              operator: e.current_operator,
              transit: e.transit,
              id: e.id,
              ... e
            }
          }
        )
      }

      itemGallery = itemGallery.map(item => {
        const seen = new Set();

        return {
          ...item,
          gallery: item.questions.filter(q => {
            if (seen.has(q.id)) return false;
            seen.add(q.id);
            return true;
          })
        };
      });
      
      return itemGallery
    }
  },
  created () {
    this.$store.dispatch('sites/get', { event: { context: this, item: { perPage: -1, page: 1 } } })
    this.$store.dispatch('users/getInspect', { event: { context: this, item: { perPage: -1, page: 1 } } })
    this.getIncident()
  },
  watch: {
    incidents (val) {
      // COMENTADO POR CAMBIO EN LA ESTRUCTURA DE DATOS
      // if (val.length > 0) {
      //   let items = []
      //   val.forEach(e => items.push(e.id))
      //   this.loadGallery = true
      //   this.$store.dispatch('incidents/getGalleryReport', {
      //     event: {
      //       context: this,
      //       id: items,
      //       type: 'json',
      //       perPage: -1,
      //       page: 1
      //     }
      //   })
      // }
    },
    actualPage () {
      let index = this.galleryNew.findIndex(e => e.id === this.idGallery)
      this.galleryNew[index].issues = this.galleryID[0].issues
    }
  },
  methods: {
    updateCurrentImageIndex(index) {
      this.currentImageIndex = index
    },
    viewImageDetails (question, evidencia) {
      this.viewItemDetails = evidencia.questions.filter(e => e.id === question.id)
      let item = evidencia.questions.find(e => e.id === question.id)
      this.comment = item.issues_notes
      this.damage = item.damage_level
      this.questionDescription = item.name
      this.imageDialogDetails = true
    },
    closeImageDetails () {
      this.imageDialogDetails = false
      this.viewItem = []
      this.comment = ''
      this.currentImageIndex = 0
    },
    closeDialog() {
      this.openFilter  = false
      this.cleanFilter()
    },
    cleanFilter() {
      this.filter = {
        year: new Date().getFullYear(),
        site: null,
        inspector: null,
         // PENDIENTE DE CONFIRMAR SI SE DEJA O NO
        // damage_level: null
      }
    },
    getInspector(user) {
     return `${user.name} ${user.last_name}`;
    },
    next (item) {
      this.loadByID = true
      this.idGallery = item.id
      this.$store.dispatch('incidents/getGallery', {
        event: {
          context: this,
          inspectionsById: item.id,
          page: item.issues.current_page+= 1,
          perPage: 5
        }
      })
    },
    prev (item) {
      this.loadByID = true
      this.idGallery = item.id
      this.$store.dispatch('incidents/getGallery', {
        event: {
          context: this,
          inspectionsById: item.id,
          page: item.issues.current_page-=1,
          perPage: 5
        }
      })
    },
    viewImage (item) {
      const scaleItem = this.levels.find(e => e.value === item.damage_level)
      this.viewItem = Object.assign({
        ...item,
        color: scaleItem ? scaleItem.color : 'default',
        text: scaleItem ? scaleItem.text : 'general.none',
      })
      this.imageDialog = true
    },
    closeImgDialog() {
      this.imageDialog = false
    },
    getIncident () {
      this.loadTable = true
      let plate = ''
      if (this.unit && this.unit.plates && this.unit.plates.length > 0) {
        this.unit.plates.forEach(e => plate = e.plate_number)
      }
      this.$store.dispatch('incidents/getAllIncidents', {
        event: {
          context: this,
          unit_id: this.unit.id,
          year: this.filter.year,
          site_id: this.filter.site,
          user_id: this.filter.inspector,
           // PENDIENTE DE CONFIRMAR SI SE DEJA O NO
          // damage_level: this.filter.damage_level,
        }
      })
      this.openFilter = false
    },
    getGraphic () {
      this.openGraphic = true
      this.loadGraphic = true
      this.$store.dispatch('monitoring/getGraphic', {
        event: {
          context: this,
          map: {
            unit: this.unit.id,
            year: this.selectYear
          }
        }
      })
    },
    /** Metodo que permite seleccionar todas las fotos */
    selectedAll () {
      if (this.allGallery) {
        this.galleryNew.forEach(e => this.selectGallery.push(e.id))
      } else {
        this.selectGallery = []
      }
    },
    downloadByInspection (id, name) {
      this.$set(this.loadReport, id, true)
      this.editedItem = name
      this.$store.dispatch('monitoring/getPDFByID', {
        event: {
          context: this,
          inspection: id,
          name: this.editedItem,
          type: 'download'
        }
      })
    },
    /** Funcionamiento para la descarga de galeria dependiendo de su seleccion */
    dowloadPhotos () {
      if (this.selectGallery.length === 0) {
        this.showNotification(this.$t('general.selectWarning'), 'warn', -1)
      } else {
        const array = new Set(this.selectGallery)
        let result = [...array]
        this.loadButton = true
        const unitId = this.unit ? this.unit.id : null;
        this.$store.dispatch('incidents/getGalleryReport', {
          event: {
            context: this,
            id: result,
            type: 'download',
            perPage: -1,
            page: 1,
            unit_id: unitId
          }
        })
        this.selectGallery = []
        this.allGallery = false
      }
    },
    /** Activa el deslizamiento de detalles de la card de la evidencia que fue seleccionado */
    active (item, idData) {
      const findEvidencia = this.galleryNew.find(e => e.id === idData)
      this.activeItem = findEvidencia.questions.find(e => e.id === item.id)
      if (this.activeItem) this.show = true
    },
    /** Desactiva y devuelve a su posicion la card de la galeria de daño */
    inactive () {
      this.show = false
    },
    /**
     * Valida y define el color correspondiente del nivel de daño
     */
    colorDamageLevel (item) {
      let color = ''
      // MEJORAR

      if (this.levels && Array.isArray(this.levels)) {
        this.levels.forEach(e => {
          if (item.damage_level === e.value) { // NOTA: Usar item.damage_level
            color = e.color
          }
        })
      } else {
        // Retorna un color por defecto si la lista de niveles no existe
        return 'grey';
      }
      return color
    }
  }
}
</script>

<style lang="css">
.card__container {
  height: 80vh;
  padding: 1px;
}
.h100 {
  height: 100%;
}

.h100__scroll {
  overflow-y: scroll;
  overflow-x: hidden;
}

::-webkit-scrollbar-track,
::-webkit-scrollbar-corner,
::-webkit-scrollbar {
  background: #f5f5f5;
  width: 6px;
  height: 6px;
}

::-webkit-scrollbar-thumb {
  border-radius: 6px;
  background: #0091FF;
}

/** Estilo para el tooltip de la grafica */
.card {
  box-shadow: 0 4px 8px 0 rgba(0,0,0,0.2);
  transition: 0.3s;
}

.card:hover {
  box-shadow: 0 8px 16px 0 rgba(0,0,0,0.2);
}
</style>